import PropTypes from "prop-types";

import { alignItems, colors, strCode } from "../../consts";
import { t } from "../../services";

import { FlexContainers, Paragraph2, SVG, WrapperContainer } from "../../components";
import { PasswordValidationWrapper } from "./styled";

const PasswordValidationInfo = ({ passwordValidationErrors }) => {
  return (
    <PasswordValidationWrapper
      Container={FlexContainers.FlexRowStart}
      alignItems={alignItems.start}
      pv={12}
      ph={14}
    >
      <WrapperContainer mt={2}>
        <SVG.InfoIcon />
      </WrapperContainer>

      <WrapperContainer
        Container={FlexContainers.FlexColumnStart}
        alignItems={alignItems.start}
        ml={10}
      >
        <Paragraph2>{t(strCode.PASSWORD_REQUIREMENTS_TITLE)}</Paragraph2>
        <ul>
          <li
            style={{
              color:
                passwordValidationErrors &&
                !passwordValidationErrors?.isValidPasswordLength &&
                colors.SALEM
            }}
          >
            {t(strCode.PASSWORD_LENGTH_REQUIREMENT)}
          </li>
          <li
            style={{
              color:
                passwordValidationErrors &&
                !passwordValidationErrors?.isValidPasswordSymbol &&
                colors.SALEM
            }}
          >
            {t(strCode.PASSWORD_SPEC_SYMBOL_REQUIREMENT)}
          </li>
          <li
            style={{
              color:
                passwordValidationErrors &&
                !passwordValidationErrors?.isValidPasswordBigSymbol &&
                colors.SALEM
            }}
          >
            {t(strCode.PASSWORD_BIG_SYMBOL_REQUIREMENT)}
          </li>
          <li
            style={{
              color:
                passwordValidationErrors &&
                !passwordValidationErrors?.isValidPasswordNumber &&
                colors.SALEM
            }}
          >
            {t(strCode.PASSWORD_NUMBER_REQUIREMENT)}
          </li>
        </ul>
      </WrapperContainer>
    </PasswordValidationWrapper>
  );
};

PasswordValidationInfo.propTypes = {
  passwordValidationErrors: PropTypes.shape({
    isValidPasswordLength: PropTypes.bool,
    isValidPasswordSymbol: PropTypes.bool,
    isValidPasswordBigSymbol: PropTypes.bool,
    isValidPasswordNumber: PropTypes.bool
  })
};

export default PasswordValidationInfo;
